import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { HelpOutline as HelpOutlineBase } from '@mui/icons-material'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
`
export const HideContainer = styled('div')`
  display: none;
`

export const Text = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 24px;
  margin: 0;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const CardTitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  margin: 0;
`

export const CardDescription = styled(Description)``

export const Info = styled('div')`
  align-items: center;
  cursor: pointer;
  display: inline-grid;
  grid-template-columns: 20px auto;
  height: 20px;
  margin: 4px 20px 8px 0;
`

export const InfoText = styled('div')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 0 8px;
  pointer-events: none;
  user-select: none;

  ${Info}:hover & {
    text-decoration: underline;
  }
`

export const InfoIcon = styled(HelpOutlineBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 1.5rem;
    pointer-events: none;
    user-select: none;
  }
`

export const DialogTitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: normal;
  line-height: 21px;
  margin: 0;
`

export const DialogDescription = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 21px;
  margin: 0;
`
